import Enumeration from '@enums/enum';

/**
 * The supported repayment types.
 */
export default new Enumeration({
  PRINCIPAL_AND_INTEREST: 'principal_and_interest',
  INTEREST_ONLY: 'interest_only',
});
